module.exports = __webpack_public_path__ + "img/62.c3cf0766.png";